import React from "react";

import { ListingList, DetailsListingRow } from "../../components/listing";
import { QuickFilter } from "../../components";

import { Counter, ListingsTopButtons } from "../atoms";
import { ListingsFilters } from "../molecules";
import { useListingList } from "../useListingList";
import { importListing } from "../services/listing";
import { isMobile } from "react-device-detect";

export function Network() {
  const {
    count,
    listParams,
    onSearchQueryChange,
    sort,
    setSort,
    filter,
    setFilter,
    inStock,
    setInStock,
  } = useListingList();

  return (
    <main id="listings-manage" className={`${!isMobile ? "mt-3" : ""}`}>
      <div className="container">
        <div
          className={`${
            !isMobile
              ? "d-flex flex-wrap justify-content-end justify-content-md-between p-3 pb-0 p-md-0 mt-4"
              : "px-3 pt-1"
          }  `}
        >
          <QuickFilter
            className={`listings ${isMobile ? "mb-1" : ""}`}
            placeholder="Quick search for products"
            onUpdate={onSearchQueryChange}
          />

          <ListingsTopButtons />
        </div>

        <div className={`p-3 list-container ${!isMobile ? "my-4" : "mt-3"}`}>
          <ListingsFilters
            {...{
              sort,
              setSort,
              filter,
              setFilter,
              inStock,
              setInStock,
            }}
          />

          <Counter count={count} />

          <ListingList
            itemComponent={DetailsListingRow}
            itemComponentProps={{
              isNetwork: true,
              importListing,
            }}
            limit={12}
            list={"network"}
            {...listParams}
          />
        </div>
      </div>
    </main>
  );
}
